export default "__VITE_ASSET__BGP3h3aT__"